<template>
	<div id="videoreview">
		<div class="lists" v-waterfall-lower="loadMore" waterfall-disabled="disabled" waterfall-offset="500">
		    <div class="list" v-for="(item,index) in breakPoints" @click="onPlay(item,index)" :key="index">
		    	<div class="img">
				 	<img :src="item.pic_url" class="stop" />
				</div>
			    <p class="title">{{item.title}}</p>
				<p>{{item.create_time}}</p>
		    </div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import tool from '../../../kits/Tools.js';
import vxxData from '../../../kits/data.js';
import { Toast } from 'vant';
import { Waterfall } from 'vant';

	export default {
		props:['breakPoint','dsId','currentMid','mid'],
		data(){
			return {
				loaded:false,
				disabled:false,
				page_nums:20,
				page:2,
				breakPoints:[]
			}
		},
		directives: {
			WaterfallLower: Waterfall('lower'),
			WaterfallUpper: Waterfall('upper'),
		},
		watch:{
		   currentMid(){
		   	if(!this.loaded && this.currentMid == this.mid){
		   		this.onRefresh();
		   	}
		   },	
		},
		mounted() {
			var img = document.getElementsByClassName('stop');
			for (var i = 0,mylength = img.length; i<mylength; i++) {
			    img[i].addEventListener("click",function(e){
			        e.preventDefault();
			    });
			}
			this.breakPoints = this.breakPoints.concat(this.breakPoint);			
        },
        methods: {
			loadMore(){
				console.log("加载更多哦")
			    this.onRefresh();
			},
			onRefresh(){
			    
				if(this.breakPoints.length<20){
					return;
				}
				
			    if(this.disabled){
			        return;
			    }
				this.disabled = true;
				var that = this;
				Toast.loading({
					mask: true,
					message: '加载中...'
				});
				var params = 'ds_id='+this.dsId+'&page_num='+this.page+"&page_size="+this.page_nums;
				this.axios.post(tool.baseUrl2()+"/init/index/getBreakPoint",params).then(function(data){
					Toast.clear();
			        if(data.data.code == "200") {
			           if(data.data.data.length>0){
			              that.breakPoints = that.breakPoints.concat(data.data.data);
			              that.page++;
			              that.disabled = false;
			           }
			           
			            that.loaded = true;
			        }
			    }).catch(function(res){
			    	Toast(res.data.message)
			    }); 
			},
        	onPlay(item,index){
        		this.$emit('switchVideo',item,index);
        	}
        }
	}
</script>

<style scoped>
.lists {
	height: 100%;
	overflow: scroll;
}

.list {
	width: 50%;
	padding: 5px;
	box-sizing: border-box;
	overflow: hidden;
	/* float: left; */
	display: inline-block;
    vertical-align:top;
}

.img {
	width: 100%;
	padding-bottom: 56.25%;
	position: relative;
	overflow: hidden;
}

.list img {
	width: 100%;
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
	height: 100%;
}

.title {
	max-height: 40px;
	overflow: hidden;
	margin: 5px 0;
	line-height: 20px;
/* 	height: 40px;
	overflow: hidden;
	margin: 5px 0;
	line-height: 20px; */
}
</style>


// WEBPACK FOOTER //
// special.vue?2746b4c9